import React, { useEffect, useRef, useState } from "react";
import searchIcon from "../../../assets/images/search-colored.svg";

const SearchBar: React.FC<any> = ({ value, onChange, label }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
    // Force re-render on iOS WebView
    if (inputRef.current) {
      inputRef.current.style.opacity = "0.99";
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.style.opacity = "1";
        }
      }, 10);
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
    // Delay to ensure WebView handles focus properly
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        // Force cursor to end of input
        const length = inputRef.current.value.length;
        inputRef.current.setSelectionRange(length, length);
      }
    }, 100);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <form className="mt-6 w-full leading-6 min-h-[48px]" role="search">
      <div className="flex gap-2.5 items-center p-3 w-full bg-white rounded-xl border border-[#4B4AD5] border-solid min-h-[48px]">
        <div className="flex flex-1 shrink gap-3 items-center self-stretch my-auto w-full basis-0 min-w-[240px]">
          <img
            loading="lazy"
            src={searchIcon}
            className="object-contain shrink-0 self-stretch my-auto w-6 aspect-square"
            alt=""
          />
          <label htmlFor="specialitySearch" className="sr-only">
            {label ?? "Search by speciality name"}
          </label>
          <input
            ref={inputRef}
            id="specialitySearch"
            className="flex-grow bg-white text-gray-500 placeholder-gray-500 focus:outline-none"
            placeholder={label ?? "Search by speciality name"}
            aria-label={label ?? "Search by speciality name"}
            value={value}
            onChange={handleInputChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            style={{
              // iOS WebView specific fixes
              WebkitAppearance: "none",
              WebkitUserSelect: "text",
              userSelect: "text",
              transform: "translateZ(0)",
              WebkitTransform: "translateZ(0)",
              willChange: "contents",
              // Force re-render when focused to show cursor
              opacity: isFocused ? 0.99 : 1,
              // Ensure text color is visible
              color: value ? "#6B7280" : "#9CA3AF",
            }}
            // iOS specific attributes
            autoCapitalize="off"
            autoCorrect="off"
            spellCheck="false"
          />
        </div>
      </div>
    </form>
  );
};

export default SearchBar;
